{
  "name": "aptem.assess.app",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --configuration development",
    "build:development": "ng build --configuration development",
    "build:pipeline": "ng build --configuration pipeline",
    "build:staging": "ng build --configuration staging",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:coverage": "ng test --no-watch --coverage",
    "serve:ssr:aptem.assess.app": "node dist/aptem.assess.app/server/server.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.0",
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/platform-browser": "^21.1.0",
    "@angular/platform-browser-dynamic": "^21.1.0",
    "@angular/platform-server": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@angular/ssr": "^21.1.0",
    "@aptem/components": "^4.0.1",
    "@aptem/styles": "^4.0.1",
    "@microsoft/applicationinsights-web": "^3.3.11",
    "@ngrx/effects": "^21.0.1",
    "@ngrx/store": "^21.0.1",
    "angular-svg-icon": "^19.1.1",
    "bootstrap": "^5.3.8",
    "express": "^5.2.1",
    "ngx-bootstrap": "^20.0.2",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "typescript-memoize": "^1.1.1",
    "zone.js": "^0.16.0"
  },
  "devDependencies": {
    "@angular/build": "^21.1.0",
    "@angular/cli": "^21.1.0",
    "@angular/compiler-cli": "^21.1.0",
    "@ianvs/prettier-plugin-sort-imports": "^4.7.0",
    "@ngrx/store-devtools": "^21.0.1",
    "@types/express": "^5.0.6",
    "@types/jasmine": "~5.1.15",
    "@types/node": "^24.10.4",
    "@vitest/browser-playwright": "^4.0.17",
    "@vitest/coverage-v8": "^4.0.17",
    "jasmine-core": "~5.13.0",
    "jsdom": "^27.4.0",
    "prettier": "3.8.0",
    "renovate": "^42.85.6",
    "typescript": "~5.9.3",
    "vitest": "^4.0.17"
  },
  "volta": {
    "node": "24.11.1"
  },
  "engines": {
    "node": ">=24.0.0",
    "npm": ">=10.0.0"
  },
  "overrides": {
    "rxjs": "$rxjs",
    "ngx-bootstrap": {
      "@angular/animations": "$@angular/animations",
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core",
      "@angular/forms": "$@angular/forms"
    },
    "angular-svg-icon": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core"
    }
  }
}
